import { render, staticRenderFns } from "./CustomFieldValueRecurring.vue?vue&type=template&id=167d93e8"
import script from "./CustomFieldValueRecurring.vue?vue&type=script&lang=js"
export * from "./CustomFieldValueRecurring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports